import { Component, inject, OnDestroy, OnInit, AfterViewInit } from '@angular/core';
import {DashboardService} from '../../../../service/events/dashboard.service';
import {Router} from '@angular/router';
import {TareasApiService} from '../../../../service/api/tareas-api.service';
import {Utils} from '../../../../common/utils';
import {RequestButtonTypes} from '../../../../common/components/request-button/request-button.component';
import {RequestHandler} from '../../../../service/OffService/request-handler';
import {Filtering} from '../../../../service/filtering/filtering';
import {BaseView} from '../../../base-view';
import { environment } from '../../../../../environments/environment';
import { StorageManager } from '../../../../common/storage-manager.class';
import moment, { Moment } from 'moment';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import { MessageService, TreeNode } from 'primeng/api';
import { TareaFertiModel } from 'src/app/models/tareas/tarea-ferti.model';
import { ColInterface } from 'src/app/common/components/common-list-table/col.interface';
import { ColStylesInterface } from 'src/app/common/components/common-list-table/col-styles.interface';
import { NavigationService } from 'src/app/service/navigation.service';
import { FertilizantesEnvironmentDefinition } from './environment-variables';
import { FertilizantesFormDefinition } from './fertilizantes-form/form-control/form-definition';
import { FormType } from 'src/app/common/components/reactive-form-builder/interfaces/form.interface';
import { createCsv } from 'src/app/common/components/reactive-form-builder/export/createCsv';

moment.locale('es');
@Component({
    selector: 'app-fito',
    standalone: false,
    templateUrl: './fertilizantes.component.html',
    styleUrls: ['./fertilizantes.component.scss']
})
export class FertilizantesComponent extends BaseView<TareaFertiModel> implements OnInit, OnDestroy, AfterViewInit {
    public years = [
        {label: '...', value: 0},
    ];

    public form: FertilizantesFormDefinition | null = null;

    public env: FertilizantesEnvironmentDefinition = new FertilizantesEnvironmentDefinition();
    
    public hiddenButtonDelete = false;
    
    public showButtonDuplicate = true;

    public isGeneratingCanvas = false;

    public showPrescripcion = false;

    public filter: Filtering<TareaFertiModel> = new Filtering<TareaFertiModel>();
    
    public getRequest: RequestHandler<TareaFertiModel[]> = this.tareasApi.fertilizantes.GET;
    
    public deleteRequest: RequestHandler<TareaFertiModel> = this.tareasApi.fertilizantes.DELETE;
    
    public pathToForm = 'crear-fertilizante-tarea';
    
    public menuItemId = 'fertilizantes';
    
    public deleteRequestButtonType: RequestButtonTypes = RequestButtonTypes.DELETE;

    public btnAnadir = 'Añadir Fertilizante';

    public receta: TareaFertiModel = {};
    
    public showReceta = false;

    public override canShow: Record<string, boolean> = {};

    public override model: TareaFertiModel = {};

    public oneToThirtySix = [
        1, 2, 3, 4,
        1, 2, 3, 4,
        1, 2, 3, 4,
        1, 2, 3, 4,
        1, 2, 3, 4,
        1, 2, 3, 4,
        1, 2, 3, 4,
        1, 2, 3, 4,
        1, 2, 3, 4
    ];
    
    public cols: ColInterface[] = [
        
        { 
            field: 'cliente_nombre', 
            header: this.env.clienteName, 
            filter: '', 
            visible: this.env.hasClients && this.env.userCanSeeClientes && !this.env.showTareasMto 
        },
        { 
            field: 'finca', 
            header: this.env.fincaName 
        },
        { 
            field: 'sectores_nombres', 
            header: this.env.sectoresName, 
            visible: this.env.showFertilizantesSectores && !this.env.showTareasMto 
        },
        { 
            field: 'parcelas_nombres', 
            header: this.env.parcelasName, 
            visible: !this.env.showTareasMto && this.env.showFertilizantesParcelas 
        },
        { 
            field: 'fecha_inicio', 
            header: 'F.\xa0Inicio', 
            visible: !this.env.showTareasMto 
        },
        { 
            field: 'fecha_fin', 
            header: 'F.\xa0Fin' 
        },
        { 
            field: 'trabajadores_nombres', 
            header: 'Empleado', 
            visible: this.env.showTareasMto || this.env.showTareasFertiHoras 
        },
        { 
            field: 'hora_inicio', 
            header: 'Hora Inicio', 
            visible: this.env.showTareasMto || this.env.showTareasFertiHoras 
        },
        { 
            field: 'hora_fin', 
            header: 'Hora Fin', 
            visible: this.env.showTareasMto 
        },
        { 
            field: 'horas_totales', 
            header: 'Horas', 
            filter: '', 
            visible: this.env.showTareasMto || this.env.tareasHorasTotales 
        },
        
        { 
            field: 'nombre_cuba', 
            header: 'Cuba', 
            visible: this.env.showFertiNombreCuba 
        },
        { 
            field: 'productos_nombres', 
            header: 'Productos' 
        },
        { 
            field: 'dosis', 
            header: 'Cantidades', 
            width: '70px' 
        },
        { 
            field: 'n', 
            header: 'N%', 
            width: '80px', 
            footer: '', 
            visible: this.env.showFertilizantesNPK 
        },
        { 
            field: 'p', 
            header: 'P%', 
            width: '80px', 
            footer: '', 
            visible: this.env.showFertilizantesNPK 
        },
        { 
            field: 'k', 
            header: 'K%', 
            width: '80px', 
            footer: '', 
            visible: this.env.showFertilizantesNPK 
        },
        { 
            field: 'ca', 
            header: 'Ca%', 
            width: '80px', 
            footer: '', 
            visible: this.env.showFertilizantesCa 
        },
        { 
            field: 's', 
            header: 'S%', 
            width: '80px', 
            footer: '', 
            visible: this.env.showFertilizantesS 
        },
        { 
            field: 'mg', 
            header: 'Mg%', 
            width: '80px', 
            footer: '', 
            visible: this.env.showFertilizantesMg 
        },
        { 
            field: 'tipo_fertilizacion', 
            header: 'Tipo\xa0Fert.', 
            visible: this.env.showTipoFertilizacion 
        },
        { 
            field: 'prioridad', 
            header: 'Prioridad', 
            filter: '', 
            visible: this.env.appName === 'ava' 
        },
        { 
            field: 'facturado', 
            header: 'Facturado', 
            filter: '', 
            visible: this.env.appName === 'agrosalvi' 
        },
        { 
            field: 'nombres_asignados', 
            header: 'Asignado', 
            filter: '', 
            visible: this.env.showAssignUserTasksFertilizante || this.env.showAssignUserInAllTasks 
        }

    ];
    
    public aplicado = {
        selected: ''
    };
    
    public validado = {
        selected: ''
    };
    
    public prioridad = {
        selected: ''
    };
    
    public totalHoras: Moment | string = '00:00';
    
    public auxTotalHoras: Moment | string = '00:00';
    
    public fecha: {inicio: string; fin: string} = {
        inicio: '',
        fin: '',
    };

    navigationService = inject(NavigationService);

    constructor(public tareasApi: TareasApiService,
        private dashboardEvents: DashboardService,
        public dashboard: DashboardService,
        private router: Router,
        private messageService: MessageService) {
        super(dashboardEvents, tareasApi.fertilizantes.GET);
    }

    ngOnInit() {

        if (this.env.showTareasMto || this.env.showTareasAplicados) {

            this.aplicado.selected = 'no-aplicados';

            if (this.env.appName === 'donjardin' && this.env.rol !== 'admin'){
                this.hiddenButtonDelete = true;
            }
            
            this.filter.addFilter((copy: TreeNode<TareaFertiModel>[] | void) => (copy as TreeNode<TareaFertiModel>[]).filter(row => {
                const tareaFerti = row as TareaFertiModel;

                switch (this.aplicado.selected) {
                case 'aplicados':
                    return [true, '1', 1].includes(tareaFerti.aplicado ?? false);
                case 'no-aplicados':
                    return [null, undefined, '0', 0].includes(tareaFerti.aplicado?.toString());
                default:
                    return true;
                }
            }));
        }

        if (this.env.showTareasPrioridad){
            this.prioridad.selected = 'No-Realizada';

            this.filter.addFilter((copy: TreeNode<TareaFertiModel>[] | void) => (copy as TreeNode<TareaFertiModel>[]).filter(row => {
                const tareaFerti = row as TareaFertiModel;

                switch (this.prioridad.selected) {
                case 'Realizada':
                    return ['Realizada'].includes(tareaFerti.prioridad ?? '');
                case 'No-Realizada':
                    return !['Realizada'].includes(tareaFerti.prioridad ?? '');
                default:
                    return true;
                }
            }));
        }

    
        if (this.env.showCampaign) {

            this.fillCampaign();
            this.filter.addFilter((copy: TreeNode<TareaFertiModel>[] | void) => (copy as TreeNode<TareaFertiModel>[]).filter(row => {
                if (this.env.selectedYears === 0) {
                    return true;
                } else {
                    return this.compareDates(row);
                }
            }));
        }

        this.tareasApi.enviarRecetaCaptura.response(() => {
            if (!this.tareasApi.enviarRecetaCaptura.hasError && this.showReceta) {
                this.messageService.add({
                    severity: 'success',
                    summary: 'Email enviado',
                    detail: 'Se ha enviado el impreso de la receta correctamente.'
                });
                this.showReceta = false;
            }
        });

        if (this.env.showRecetaFertiAgrogest || this.env.showRecetaFertiPascualCabedo) {
            this.showPrescripcion = true;
        }

        this.dashboardEvents.setSubmenuItem('fertilizantes');
        this.getRequest.response(() => {
            setTimeout(() => {
                this.updateFooter();
            }, 1);
        });

         if (environment.features.showTareasMto) {
            /*** 
            *  En el caso de que el usuario no se admin,
            * filtrará por su id de usuario que coincide,
            *  con el id trabajador   
            */
            if (StorageManager.getUser().rol !== 'admin' && this.env.appName !== 'detorres') {
                this.filter.addFilter((copy: TreeNode<TareaFertiModel>[] | void) => (copy as TreeNode<TareaFertiModel>[]).filter(row => {
                    const tareaFerti = row as TareaFertiModel;

                    if (tareaFerti.ids_trabajadores != null) {

                        const idTrabajador = StorageManager.getUser().id;
                        const listaTrabajadores = (tareaFerti.ids_trabajadores as string).split(';');
                        
                        if (listaTrabajadores.includes(idTrabajador.toString())) {
                            return true;
                        }

                    }
                    return false;
                }));
            }

            /*** 
            *  Fin de filtrar por id_usuario = trabajador,
            *   
           */
        }
       
        /**
             *  Activado la asignacion de usuarios en la tabla tareas
             *  Filtraremos las tareas si en caso de que el usuario se encuentre como asignado en la tarea
             *  Para su funcionamiento la referencia se obtiene de una recopilacion en php 
             */
        // if (environment.features.showAssignUserTasksFertilizante || environment.features.showAssignUserInAllTasks) {
        if (this.env.appName === 'ava'){
            /** Solo el que tiene el rol de admin podra ver todas las tareas */
            if (StorageManager.getUser().rol !== 'admin') {
                this.filter.addFilter((copy: TreeNode<TareaFertiModel>[] | void) => (copy as TreeNode<TareaFertiModel>[]).filter(row => {
                    const tareaFerti = row.data as TareaFertiModel;

                    if (tareaFerti.referencia_usuario != null) {

                        const idTrabajador = StorageManager.getUser().id;
                        const listaTrabajadores = (tareaFerti.referencia_usuario as string).split(';');
                        if (listaTrabajadores.includes(idTrabajador)) {
                            return true;
                        }

                    }
                    return false;
                }));
            }
        }// Fin filtro asignados
        
        if (this.env.betweenDates) {
            const nameDate = 'fecha_fin';
            this.filter.addFilter((copy: TreeNode<TareaFertiModel>[] | void) => (copy as TreeNode<TareaFertiModel>[]).filter(row => {
                const tareaFerti = row as TareaFertiModel;

                if (this.fecha.inicio && this.fecha.fin) {
                    if (tareaFerti[nameDate] == null) {
                        return false;
                    } else {
                        const arrayFecha = tareaFerti[nameDate].toString().split('/');
                        const fechaAux = arrayFecha[2] + '-' + arrayFecha[1] + '-' + arrayFecha[0];

                        if (
                            (moment(moment(this.fecha.inicio).format('YYYY-MM-DD')).diff(fechaAux) <= 0) && 
                            (moment(moment(this.fecha.fin).format('YYYY-MM-DD')).diff(fechaAux) >= 0)
                        ) {
                            return true;
                        } else {
                            return false;
                        }
                    }

                } else {
                    return true;
                }
            }));
        }
    }

    public globalConditionalStyle(value: string, col: ColInterface): ColStylesInterface {
        if ( col.field === 'horas_totales') {
            return {
                textAlign: 'center'
            };
        }
      
        if (col.field === 'nombre_cuba') {
            return {
                textAlign: 'center',
            };
        }
        if (col.field === 'prioridad') {
            if (value === 'Alta') {
                return {
                    textAlign: 'center',
                    rowStyle: {
                        backgroundColor: '#f44242'
                    },  
                };
            }
            else if (value === 'Realizada'){
                return {
                    textAlign: 'center',
                    rowStyle: {
                        backgroundColor: '#00ff00'
                    },  
                };
            }
        }

        return {textAlign: 'center'};
    }

    public globalVisualTransform(value: string, col: ColInterface, row: TreeNode<TareaFertiModel>) {
        const tareaFerti = row.data as TareaFertiModel;

        if (col.field === 'tipo_fertilizacion') {
            switch (value) {
            case '1':
                return 'Abono de Fondo';
            case '2':
                return 'Abono de Cobertera';
            case '3':
                return 'Aplicación de Enmienda';
            }
        }

        if (Utils.isNumber(value) && col.field !== 'finca' && col.field !== 'facturado' && col.field !== 'dosis1') {
            // formato decimal y millar
            return Utils.decimalFormat(value, 2, '.', ',', 3);
        }

        if (col.field === 'parcelas_nombres') {
            const str = Utils.replaceAll(Utils.replaceAll((tareaFerti[col.field]?.toString() || ''), '- ', ''), '\n', '\n, ');
            value = str.substring(0, str.length - 2);
            return (value.length > 50) ? value.slice(0, 50 - 1) + '…' : value;
        }

        if (col.field === 'sectores_nombres') {
            const str = Utils.replaceAll(Utils.replaceAll((tareaFerti[col.field]?.toString() || '' ), '- ', ''), '\n', '\n, ');
            value = str.substring(0, str.length - 2);
            return (value.length > 50) ? value.slice(0, 50 - 1) + '…' : value;
        }

        if (col.field === 'productos_nombres') {
            const str = Utils.replaceAll(tareaFerti[col.field]?.toString() || '', ';', ', ');
            value = str.substring(0, str.length - 2);
            return (value.length > 50) ? value.slice(0, 50 - 1) + '…' : value;
        }

        if (col.field === 'dosis') {
            const str = Utils.replaceAll(tareaFerti[col.field]?.toString() || '', ';', ', ');
            value = str.substring(0, str.length - 2);
            return (value.length > 50) ? value.slice(0, 50 - 1) + '…' : value;
        }

        if (col.field === 'facturado') {
            switch (value) {
            case '0':
                return 'No';
            case '1':
                return 'Sí';
            default:
                return 'No';
            }
        }

        return value;
    }

    public filtrarRealizados(value: string, from = 'prioridad') {
        if (from === 'prioridad') {
            this.prioridad.selected = this.prioridad.selected === value ? '' : value;
        }
    
        this.filter.filter();
        this.updateFooter();
    }

    public addFertilizante() {
        if (this.env.hasClients && this.env.userCanSeeClientes) {
            const cliente = StorageManager.getClient();
            if (!cliente || !cliente.id) {
                this.dashboard.openClientDialog();
                return;
            }
        }
        this.router.navigate(['dashboard', 'crear-fertilizante-tarea']);
    }

    public add() {
        this.router.navigate(['dashboard', this.pathToForm]);
    }

    public edit(data: TareaFertiModel) {
        this.router.navigate(['dashboard', 'editar-fertilizante-tarea', data.id, data]);
    }

    public duplicate(data: TareaFertiModel) {
        this.router.navigate(['dashboard', 'duplicar-fertilizante-tarea', data.id, data]);
    }

    public override deleteRegister() {
        if (this.model.id) {
            this.deleteRequest.safePerform(this.model);
            this.deleteRequest.response(() => {
                if (!this.deleteRequest.hasError) {
                    this.getRequest.safePerform();
                }
            });
        } else {
            this.deleteRequest.hasError = true;
            throw new Error('Trying to DELETE a register without primary key');
        }
    }

    public override async show(modal: string, data: TareaFertiModel) {
        this.model = data;
       
        this.formatDiasSemana();

        super.show(modal, this.model);

        const formType = modal === 'delete' ? +FormType.DELETION : +FormType.INFORMATIVE;
        
        this.form = new FertilizantesFormDefinition(formType, data as Record<string, string>, null, [], []);
    }

    public generarTablaAbonado() {
        this.show('tablaAbonado', {});
    }

    public override sum(field: string) {
        let sum = 0;

        if (field === 'horas_totales') {
            this.sumHours();
        } else {
            (this.filter.value || []).forEach(it => {
                sum += +((it as TareaFertiModel)[field] || 0);
             });

            this.cols.forEach(it => {
                if (it.field === field) {
                    it.footer = Utils.decimalFormat(sum + '', 2, '.', ',', 3);
                }
            });
        }

    }

    public override updateFooter() {
        ['n', 'p', 'k', 'ca', 'horas_totales'].forEach(it => this.sum(it));
        if ( this.env.betweenDates ) {
            this.sumHours();
        }
    }

    public formatDiasSemana() {
        const dias = (this.model.dias_semana || '').split(';');
        const arrDias: string[] = [];
        this.model.dias_semana_formatted = '';

        dias.forEach((dia: string) => {
            if (dia === 'L') { arrDias.push('Lunes'); }
            if (dia === 'M') { arrDias.push('Martes'); }
            if (dia === 'X') { arrDias.push('Miércoles'); }
            if (dia === 'J') { arrDias.push('Jueves'); }
            if (dia === 'V') { arrDias.push('Viernes'); }
            if (dia === 'S') { arrDias.push('Sábado'); }
            if (dia === 'D') { arrDias.push('Domingo'); }
        });

        arrDias.forEach((dia, index) => {
            this.model.dias_semana_formatted += dia;
            if (index !== arrDias.length - 1) {
                this.model.dias_semana_formatted += ', ';
            }
        });
    }

    public generarReceta(data: TareaFertiModel) {
        this.tareasApi.enviarRecetaCaptura.hasError = false;
        this.tareasApi.enviarRecetaCaptura['error'] = null;

        this.model = data;
        this.formatDiasSemana();
        this.receta = this.model;
        
        this.showReceta = true;
    }

    public enviarCorreo() {

        this.isGeneratingCanvas = true;
        const config = this.getPrintConfig();

        html2canvas(
            document.getElementById('html2canvasDiv') ?? new HTMLElement(), 
            { scale: config.canvasScale, logging: false }
        ).then(canvas => {
            this.isGeneratingCanvas = false;

            const pdf = new jsPDF(config.orientation, 'mm', 'a4');
            const data = canvas.toDataURL('image/png');
            
            if (canvas.width > canvas.height) {
                pdf.addImage(data, 'png', 0, 0, config.width, (canvas.height / (canvas.width / config.width)), 'alias', 'FAST');
            } else {
                pdf.addImage(data, 'png', 0, 0, (canvas.width / (canvas.height / config.height)), config.height, 'alias', 'FAST');
            }

            const adjunto = encodeURIComponent(window.btoa(pdf.output()));

            let email = '';
            if (this.receta.finca_email) {
                email = this.receta.finca_email;
            } else if (this.receta.cliente_email) {
                email = this.receta.cliente_email;
            } else {
                email = '';
            }
      
            if (email !== '') {
                this.tareasApi.enviarRecetaCaptura.perform({
                    email,
                    generado: adjunto,
                    finca: this.receta.finca,
                    tratamiento: this.receta.tratamiento_nombre ? this.receta.tratamiento_nombre : 'fertilizante',
                } as never);
              
            } else {
                this.tareasApi.enviarRecetaCaptura.hasError = true;
                this.tareasApi.enviarRecetaCaptura['error'] = 'El cliente o finca no tiene un email asociado';
            }
            return;
        }).catch (e => {
            console.log('catch en getPosition: ' + e);
        }
        ).then(() => {
            console.log('Adjuntos generados.');
            return;
        }, error => {
            console.log(error);
            this.tareasApi.enviarRecetaCaptura.hasError = true;
            this.tareasApi.enviarRecetaCaptura['error'] = 'Error al enviar email';
        }).catch (e => {
            console.log('catch en getPosition: ' + e);
        }
        );
    }
    
    public enviarWhatsapp() {
        window.open('https://web.whatsapp.com/', '_blank');
    }


    public imprimirReceta() {
        this.isGeneratingCanvas = true;
        const config = this.getPrintConfig();

        html2canvas(
            document.getElementById('html2canvasDiv') ?? new HTMLElement(), 
            { scale: config.canvasScale, logging: false }
        ).then(canvas => {
            this.isGeneratingCanvas = false;
            const pdf = new jsPDF(config.orientation, 'mm', 'a4');
            const data = canvas.toDataURL('image/png');
            
            if (this.env.appName === 'esparragosgranada') {

                pdf.addImage(data, 'png', 0, 0, config.width, 180 , 'alias', 'FAST');  

            } else {

                if (canvas.width > canvas.height) {
                    pdf.addImage(data, 'png', 0, 0, config.width, (canvas.height / (canvas.width / config.width)) , 'alias', 'FAST');  
                } else {
                    pdf.addImage(data, 'png', 0, 0, (canvas.width / (canvas.height / config.height)), config.height , 'alias', 'FAST');
                }
            }

            pdf.save(
                (this.receta.cliente_nombre || '.').replace('.', '')
                + ' - ' +
                (this.receta.finca || '.').replace('.', '')
            );
            return;
        }).catch (e => {
            console.log('catch en getPosition: ' + e);
        }
        );
    }

    
    public getPrintConfig() {
        const config: {canvasScale: number; orientation: 'p'|'l'; width: number; height: number} = {
            canvasScale: 2,
            orientation: 'l',
            width: 290,
            height: 210
        };

        switch (this.env.appName) {
        case 'pascualcabedo':
            config.orientation = 'p';
            config.width = 210;
            config.height = 290;
            config.canvasScale = 0.86;
            break;
        case 'armentia':
            config.width = 240;
            config.height = 250;
            break;                
        default:
            break;
        }


        return config;
    }

    public override hide(modal: string) {
        this.model = {};
        this.canShow[modal] = false;
        this.deleteRequest.reset();
    }

    public override ngOnDestroy() {  
        Utils.unsuscribe([
            this.tareasApi.fertilizantes.GET
        ]);
    }

    
    modalCampaign() {
        this.env.modalShowCampaign = true;
    }

    closeModalShowCampaign() {
        this.env.modalShowCampaign = false;
    }

    selectedCampaign(){
        this.filter.filter();
        this.updateFooter();
    }

    compareDates( row: TreeNode<TareaFertiModel> ) {
        const tareaFerti = row as TareaFertiModel;
        if ( tareaFerti.fecha_inicio == null || tareaFerti.fecha_inicio.length === 0 ) {
            return false;
        }
        
        const auxFecha = tareaFerti.fecha_inicio.split('/');
        const nuevaFecha = moment(auxFecha[2] + '-' + auxFecha[1] + '-' + auxFecha[0] );
        const fechaComparar = moment('20' + (this.env.selectedYears).toString() + '-07' + '-01' );
        const fechaMax = moment('20' + (this.env.selectedYears + 1 ).toString() + '-06' + '-30' );

        if ( (nuevaFecha > fechaComparar) && (nuevaFecha < fechaMax) ){
            return true;
        } else {
            return false;
        }
    }
    
    /**
     *  Rellena el listado de campañas
     */
    fillCampaign () {
        const fechaActual = new Date().getFullYear();
        let fechaDosDigitos = 0;
        
        for (let index = 2020; index <= fechaActual; index++) {
            fechaDosDigitos = parseInt( (index.toString()).substring(2, 4) , 10);
            this.years.push({ 
                label: environment.features.applicationType === 'cropgest' ? index.toString() : 
                    (index.toString() + '-' + (fechaDosDigitos + 1 ).toString()), value: fechaDosDigitos 
            });
            
        }
    }

    public filtrarTratamientos(value: string, from = 'switch_aplicados') {
        if (from === 'switch_aplicados') {
            this.aplicado.selected = this.aplicado.selected === value ? '' : value;
        } 

        this.filter.filter();
        
        if ( this.env.betweenDates) {
            this.sumHours();
        }
    }

    public downloadCsv() {
        this.form = new FertilizantesFormDefinition(
            +FormType.EXPORT,
            this.filtering.value as unknown as Record<string, string>,
            null,
            [],
            []
        );
        const csvContent = createCsv(this.form.fieldNames, this.form.fieldLabels, this.filtering.value as TareaFertiModel[]);
        const csvLink = document.getElementById('csvLink') as HTMLAnchorElement;

        csvLink.download = this.form.formFields.name + '.csv';
        csvLink.href = encodeURI(csvContent);
        csvLink.click();
    }

    
      
    /** Parse "HH:mm" to minutes. Returns 0 if invalid. */
    public parseHHMM(v: unknown): number {
        if (typeof v !== 'string') {return 0;}
        const m = v.trim().match(/^(\d{1,2}):([0-5]\d)$/); // accept 0–23:00..59 (o 0–99 hores si vols)

        if (!m) {return 0;}
        const h = parseInt(m[1] ?? '', 10);
        const mins = parseInt(m[2] ?? '', 10);

        if (!Number.isFinite(h) || !Number.isFinite(mins)) {return 0;}
        return h * 60 + mins;
    }

    public sumHours(): void {
        const rows = (this.filter.value as Array<{ horas_totales?: unknown }>) ?? [];

        const totalMinutes = rows.reduce((acc, row) => acc + this.parseHHMM(row?.horas_totales), 0);

        const hours = Math.floor(totalMinutes / 60);
        const minutes = totalMinutes % 60;

        this.totalHoras = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;

         this.cols.forEach(it => {
            if (it.field === 'horas_totales') {
                 it.footer = this.totalHoras.toString();
            }
        });
        this.filter.filter();
    }

    getFechaInicio( event: string) {
        this.fecha.inicio = event;
        this.filter.filter();
        this.updateFooter();
        
    }
    getFechaFin( event: string) {
        this.fecha.fin = event;
        this.filter.filter();
        this.updateFooter();
    }
      
    ngAfterViewInit() {
        this.tareasApi.fertilizantes.GET.response(() => {
            this.updateFooter();
        });
    }
      
}
